import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { ProductShowcase } from './components/ProductShowcase';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Comparison } from './components/Comparison';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostTable } from './components/CostTable';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { FloatingToast } from './components/FloatingToast';
const testimonialsRow1 = [{
  initials: 'MG',
  location: 'Córdoba',
  text: 'Organicé toda la semana en una tarde. La planilla del domingo me ahorra una hora de decisiones todos los días.'
}, {
  initials: 'LP',
  location: 'Rosario',
  text: 'Las legumbres por fin salen bien. El Tomo 5 es el favorito de toda la familia.'
}, {
  initials: 'RM',
  location: 'Buenos Aires',
  text: 'Mis cenas de lunes a viernes por fin tienen variedad real. El Tomo Cero Hornalla vale cada peso.'
}];
const testimonialsRow2 = [{
  initials: 'CR',
  location: 'Mendoza',
  text: 'La Planilla Maestra me salvó la vida. Ya no pienso qué cocinar de lunes a viernes. Está decidido desde el domingo en 7 minutos.'
}, {
  initials: 'SC',
  location: 'La Plata',
  text: 'El primer mes con el Método Chango Lleno ahorré $45.000 pesos en supermercado. Y comimos mejor que antes.'
}, {
  initials: 'PA',
  location: 'Neuquén',
  text: 'El Tomo de Legumbres sin Miedo fue una revelación. Los garbanzos tostados ahora los pide toda la familia como snack.'
}];
export function App() {
  return <div className="min-h-screen bg-brand-dark text-white font-sans selection:bg-brand-gold selection:text-black" data-id="element-0">
      <Header data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <SocialProofBar data-id="element-4" />

        <div className="bg-brand-darker" data-id="element-5">
          <Testimonials testimonials={testimonialsRow1} data-id="element-6" />
        </div>

        <PainPoints data-id="element-7" />
        <ProductShowcase data-id="element-8" />
        <Bonuses data-id="element-9" />
        <Pricing data-id="element-10" />
        <Comparison data-id="element-11" />

        <div className="bg-brand-dark" data-id="element-12">
          <div className="text-center pt-20 pb-4" data-id="element-13">
            <h2 className="text-3xl font-bold flex items-center justify-center gap-2" data-id="element-14">
              <span className="text-red-500" data-id="element-15">❤️</span> MÁS PERSONAS QUE YA LO
              TIENEN
            </h2>
          </div>
          <Testimonials testimonials={testimonialsRow2} data-id="element-16" />
        </div>

        <Guarantee data-id="element-17" />
        <FAQ data-id="element-18" />
        <CostTable data-id="element-19" />
        <FinalCTA data-id="element-20" />
      </main>

      <Footer data-id="element-21" />
      <FloatingToast data-id="element-22" />
    </div>;
}